import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Link, useLocation } from 'react-router-dom';
import React, { useEffect, useState, useRef, useMemo } from 'react';

import {
  getAllTemplate,
  getAllBooking,
  getFinalAgreementChecklist,
  getActiveBooking,
  getPendingBooking,
  getProfile,
  getBooking,
  getBookingStatus,
  resetPasswordAuthenticate,
  resetBooking,
  getRecommendedVehicle,
  uploadBookingAgreement,
  getCheckInImage,
  getProgressMessages,
  getVehicleByVin,
  createExtensionRequest,
} from '../../core/data/redux/action';
import { Modal } from 'bootstrap';

import DashboardMenu from './common/dashboard-menu';
import { useSelector, useDispatch } from 'react-redux';
import { AppDispatch, RootState } from '../../core/data/redux/store';
import { Calendar } from 'primereact/calendar';
import Pagination from '../common/pagination';
import Lottie from 'lottie-react';
import Loader from '../../core/data/img/car_loading.json';
import { all_routes } from '../router/all_routes';
import ViewBooking from '../../core/data/modals/viewBooking';
import CancelBooking from '../../core/data/modals/cancelBooking';
import BookingPayment from '../booking/booking-payment';
import UploadLicense from '../../core/data/modals/uploadLicense';
import Checkout from '../../core/data/modals/checkout';
import Checkin from '../../core/data/modals/checkin';

import ContactConfirm from '../../core/data/modals/contactConfirm';
import EnquiryForm from '../../core/data/modals/enquiry';
import PreliminaryAgreement from '../../core/data/modals/preliminaryAgreement';
import SignaturePad from 'signature_pad';
import BookingAttachment from '../../core/data/modals/bookingAttachment';
import dayjs from 'dayjs';
import ImageWithBasePath from '../../core/data/img/ImageWithBasePath';
import { Tooltip } from 'react-tooltip';
import { useForm, SubmitHandler } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { generateTimeOptions } from '../../core/data/redux/actions/commonActions';
import { addContactUs, resetContactUs } from '../../core/data/redux/action';
import { formatDateWithTime } from '../../core/data/redux/actions/commonActions';
import * as Yup from 'yup';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import customParseFormat from 'dayjs/plugin/customParseFormat';

import { DatePicker, TimePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
// import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
dayjs.extend(customParseFormat);

import {
  Typography,
  Stepper,
  StepContent,
  Step,
  StepLabel,
} from '@mui/material';
import 'react-tooltip/dist/react-tooltip.css';
import { Spinner } from 'reactstrap';

const UserBookings = () => {
  const routes = all_routes;
  const [searchInput, setSearchInput] = useState('');
  const [activeStatus, setActiveStatus] = useState<number | null>(null);
  const [timeOptions, setTimeOptions] = useState<string[]>([]);
  const [showCalendar, setShowCalendar] = useState(false);
  const [dates, setDates] = useState<Date[]>([]);
  const [booking, setBooking] = useState([]);
  const signRef = useRef<HTMLCanvasElement | null>(null);
  const [first, setFirst] = useState(0);
  const [debouncedSearch, setDebouncedSearch] = useState(searchInput);
  const [toastMessage, setToastMessage] = useState('');
  const [toastClass, setToastClass] = useState('bg-success text-white');
  const dispatch = useDispatch<AppDispatch>();
  const [userPendingBookings, setUserPendingBookings] = useState<any[]>([]);
  const [cartBookings, setCartBookings] = useState<any[]>([]);
  const [carDetails, setCarDetails] = useState<any[]>([]);
  const [availabilityStartDate, setAvailabilityStartDate] =
    useState<Date | null>(null);
  const [availabilityEndDate, setAvailabilityEndDate] = useState<Date | null>(
    null
  );

  const termsRef = useRef(null);
  const signaturePad = useRef(null);
  const savedSignature = useRef(null); // To store drawing data
  const [showScrollTop, setShowScrollTop] = useState(false);
  const [isAccepted, setIsAccepted] = useState(false);
  const [userBookings, setUserBookings] = useState<any[]>([]);
  const [userActiveBookings, setUserActiveBookings] = useState<any[]>([]);
  // const [bookingDetails, setBookingDetails] = useState<any | null>(null);
  const [isMobile] = useState(window.innerWidth <= 767);
  const [step, setStep] = useState(0);

  const [isExtendModalOpen, setIsExtendModalOpen] = useState(false);
  const [selectedBooking, setSelectedBooking] = useState<any>(null);
  const [extensionDate, setExtensionDate] = useState<dayjs.Dayjs | null>(null);
  const [extensionTime, setExtensionTime] = useState<dayjs.Dayjs | null>(null);
  const [isDatePickerOpen, setIsDatePickerOpen] = useState(false);
  const [isTimePickerOpen, setIsTimePickerOpen] = useState(false);

  const dataURLToBlob = (dataURL: any) => {
    const arr = dataURL.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
  };

  const handleScroll = () => {
    const el = termsRef.current;
    if (!el) return;
    const isBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 300;
    setShowScrollTop(isBottom);
    setIsAccepted(isBottom);
  };

  useEffect(() => {
    dispatch(getAllTemplate());

    dispatch(getProgressMessages());
  }, []);

  const scrollToTop = () => {
    if (termsRef.current) {
      termsRef.current.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
  };

  const scrollToBottom = () => {
    if (termsRef.current) {
      termsRef.current.scrollTo({
        top: termsRef.current.scrollHeight,
        behavior: 'smooth',
      });
    }
  };

  const clearSignature = () => {
    const canvas = signaturePad.current;
    if (canvas) {
      signaturePad?.current.clear();
      savedSignature.current = null;
    }
    // setSignature(null);
  };

  const handleAccept = () => {
    if (signaturePad.current?.isEmpty()) {
      return;
    }

    const dataURL = signaturePad?.current.toDataURL('image/png');
    const blob = dataURLToBlob(dataURL);

    if (blob) {
      const fileName = `${user?.first_name}_signature_${user?.id}_${bookingDetail?.id}.png`;
      const signFile = new File([blob], fileName, { type: 'image/png' });

      const formData = new FormData();

      const data = {
        upload_type: getAttachmentStatus(
          'upload',
          '',
          bookingDetail?.final_agreement_review_enabled
            ? 'final_agreement_signature'
            : 'signature'
        )
          ? 'reupload'
          : 'initial',
        booking_id: bookingDetail?.id,
        billing_terms_conditions: isAccepted,
        final_agreement: bookingDetail?.final_agreement_review_enabled
          ? true
          : false,
        checklist_checked: bookingDetail?.final_agreement_review_enabled
          ? true
          : false,
      };

      Object.entries(data).forEach(([key, value]) => {
        formData.append(key, value);
      });

      formData.append(`attachments[0][file]`, signFile);
      formData.append(
        `attachments[0][label]`,
        bookingDetail?.final_agreement_review_enabled
          ? 'final_agreement_signature'
          : 'signature'
      );
      formData.append(`attachments[0][type]`, 'upload');
      dispatch(uploadBookingAgreement(formData));
    }
  };

  const {
    bookingCancelSuccess,
    bookingCancelError,
    contactUsSuccess,
    finalAgreementChecklist,
    contactUsError,
    contactUsLoading,
    pendingBookings,
    activeBookings,
    bookingUploadLicenseSuccess,
    bookingUploadLicenseError,
    // bookingDetailLoading,
    bookingDetail,
    systemSettings,
    templateList,
    bookingsSuccess,
    bookingsError,
    user,
    bookingsLoading,
    bookings,
    bookingStatusList,
    vehicleRecommendationLoading,
    vehicleRecommendationList,
    progressMessages,

    bookingUploadAgreementLoading,
    bookingUploadAgreementSuccess,
    bookingUploadAgreementError,

    checkInCarImagesSuccess,
    checkInCarImagesError,

    carDetail,
    extensionRequestSuccess,
    extensionRequestError,
    extensionRequestLoading,
  } = useSelector((state: RootState) => ({
    bookings: state.booking.bookings,
    bookingStatusList: state.booking.bookingStatusList,
    bookingsLoading: state.booking.bookingsLoading,
    user: state.auth.user,
    vehicleRecommendationLoading:
      state.vehicleRecommendation.vehicleRecommendationLoading,
    vehicleRecommendationList:
      state.vehicleRecommendation.vehicleRecommendationList,
    bookingsSuccess: state.booking.bookingsSuccess,
    bookingsError: state.booking.bookingsError,
    templateList: state.template.templateList,
    systemSettings: state.auth.systemSettings,
    bookingDetail: state.booking.bookingDetail,
    // bookingDetailLoading: state.booking.bookingDetailLoading,
    bookingUploadLicenseSuccess: state.booking.bookingUploadLicenseSuccess,
    bookingUploadLicenseError: state.booking.bookingUploadLicenseError,
    contactUsLoading: state.contactUs.contactUsLoading,
    contactUsSuccess: state.contactUs.contactUsSuccess,
    contactUsError: state.contactUs.contactUsError,
    activeBookings: state.booking.activeBookings,
    pendingBookings: state.booking.pendingBookings,
    finalAgreementChecklist: state.booking.finalAgreementChecklist,
    progressMessages: state.booking.progressMessages,
    bookingCancelSuccess: state.booking.bookingCancelSuccess,
    bookingCancelError: state.booking.bookingCancelError,

    bookingUploadAgreementLoading: state.booking.bookingUploadAgreementLoading,
    bookingUploadAgreementSuccess: state.booking.bookingUploadAgreementSuccess,
    bookingUploadAgreementError: state.booking.bookingUploadAgreementError,

    checkInCarImagesSuccess: state.booking.checkInCarImagesSuccess,
    checkInCarImagesError: state.booking.checkInCarImagesError,

    carDetail: state.vehicle.carDetail,

    extensionRequestSuccess: state.booking.extensionRequestSuccess,
    extensionRequestError: state.booking.extensionRequestError,
    extensionRequestLoading: state.booking.extensionRequestLoading,
  }));

  const [availabilityFromTime, setAvailabilityFromTime] = useState(
    systemSettings?.booking_start_time
  );
  const [availabilityUntilTime, setAvailabilityUntilTime] = useState(
    systemSettings?.booking_end_time
  );

  useEffect(() => {
    setCartBookings(
      vehicleRecommendationList?.recommendation
        ? [vehicleRecommendationList.recommendation]
        : []
    );
  }, [vehicleRecommendationList]);

  useEffect(() => {
    setUserActiveBookings(activeBookings?.data || []);
  }, [activeBookings]);

  useEffect(() => {
    setUserBookings(bookings?.data || []);
  }, [bookings]);

  useEffect(() => {
    setUserPendingBookings(pendingBookings?.data || []);
  }, [pendingBookings]);

  useEffect(() => {
    if (
      systemSettings?.booking_start_time &&
      systemSettings?.booking_end_time
    ) {
      const options = generateTimeOptions(
        systemSettings.booking_start_time,
        systemSettings.booking_end_time,
        0
      );
      setTimeOptions(options);
    }
  }, [systemSettings]);

  useEffect(() => {
    if (isAccepted && signRef.current) {
      signaturePad.current = new SignaturePad(signRef.current);
    }

    if (isAccepted && savedSignature.current && signaturePad.current) {
      signaturePad.current.fromData(savedSignature.current); // Restore previous signature
    }
  }, [isAccepted]);

  useEffect(() => {
    return () => {
      if (signaturePad.current && !isAccepted) {
        savedSignature.current = signaturePad.current.toData();
      }
    };
  }, [isAccepted]);

  const closeModal = () => {
    const checkoutModalElement = document.getElementById('checkout');
    const backdrop = document.querySelector('.modal-backdrop');

    if (
      checkoutModalElement &&
      checkoutModalElement.style.display !== 'hidden'
    ) {
      checkoutModalElement.classList.remove('show');
      checkoutModalElement.style.display = 'none';
      checkoutModalElement.classList.remove('show', 'modal-open');
    }

    if (backdrop) {
      backdrop.remove();
    }

    document.body.classList.remove('modal-open');
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';
  };

  const closeCancelModal = () => {
    const cancelModalElement = document.getElementById('cancel_booking');
    const backdrop = document.querySelector('.modal-backdrop');

    if (cancelModalElement && cancelModalElement.style.display !== 'hidden') {
      cancelModalElement.classList.remove('show');
      cancelModalElement.style.display = 'none';
      cancelModalElement.classList.remove('show', 'modal-open');
    }

    if (backdrop) {
      backdrop.remove();
    }

    document.body.classList.remove('modal-open');
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';
  };

  const closeContactModal = () => {
    const modalElement = document.getElementById('enquiry');
    const backdrop = document.querySelector('.modal-backdrop');

    if (modalElement) {
      modalElement.style.display = 'none';
      modalElement.classList.remove('show', 'modal-open');
    }

    if (backdrop) {
      backdrop.remove();
    }

    document.body.classList.remove('modal-open');
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';
    document.body.classList.remove('modal-open');
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';
  };

  const viewBooking = (id: any) => {
    dispatch(getBooking(id));
  };

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(searchInput);
    }, 500);

    return () => clearTimeout(handler);
  }, [searchInput]);

  useEffect(() => {
    setToastMessage('');

    if (localStorage.getItem('token')) {
      dispatch(getProfile());
    }

    dispatch(getRecommendedVehicle());

    dispatch(getBookingStatus());
  }, [dispatch]);

  const handlePaymentClick = (event: React.MouseEvent, bookings: any) => {
    event.preventDefault();
    setBooking(bookings);
    // setShowMenu(false);
  };

  const handleOpenExtendModal = (booking: any) => {
    setSelectedBooking(booking);
    setIsExtendModalOpen(true);
    setExtensionDate(dayjs(`${booking.booking_return_date} ${booking.booking_return_time}`, 'YYYY-MM-DD HH:mm:ss'));
    setExtensionTime(dayjs(`${booking.booking_return_date} ${booking.booking_return_time}`, 'YYYY-MM-DD HH:mm:ss'));
    setIsDatePickerOpen(false);
    setIsTimePickerOpen(false);
  };

  // Handle closing the extend modal
  const handleCloseExtendModal = () => {
    setIsExtendModalOpen(false);
    setSelectedBooking(null);
    setExtensionDate(null);
    setExtensionTime(null);
    setIsDatePickerOpen(false);
    setIsTimePickerOpen(false);
  };

  // Handle DatePicker focus
  const handleDatePickerFocus = () => {
    setIsDatePickerOpen(true);
    setIsTimePickerOpen(false); // Close TimePicker if open
  };

  // Handle TimePicker focus
  const handleTimePickerFocus = () => {
    setIsTimePickerOpen(true);
    setIsDatePickerOpen(false); // Close DatePicker if open
  };

  // Handle click outside to close pickers
  const handleClickOutside = (event: MouseEvent) => {
    const target = event.target as HTMLElement;
    if (
      !target.closest('.MuiPickersPopper-root') &&
      !target.closest('.MuiInputBase-root')
    ) {
      setIsDatePickerOpen(false);
      setIsTimePickerOpen(false);
    }
  };

  // Add click outside listener
  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // Handle extension request submission
  const handleExtendBooking = () => {
    if (!selectedBooking || !extensionDate || !extensionTime) {
      showToast('Please select both date and time for the extension.');
      return;
    }

    const data = {
      booking_id: selectedBooking.id,
      requested_end_date: extensionDate.format('YYYY-MM-DD'),
      requested_end_time: extensionTime.format('HH:mm:ss'),
    };

    dispatch(createExtensionRequest(data));
  };

  // Handle extension request success/error
  useEffect(() => {
    if (extensionRequestSuccess) {
      showToast(extensionRequestSuccess);
      handleCloseExtendModal();
      dispatch(resetBooking());
    } else if (extensionRequestError) {
      showToast(extensionRequestError);
      dispatch(resetBooking());
    }
  }, [extensionRequestSuccess, extensionRequestError]);

  useEffect(() => {
    if (
      bookingsSuccess ||
      bookingCancelSuccess ||
      bookingUploadAgreementSuccess
    ) {
      showToast(
        bookingsSuccess || bookingCancelSuccess || bookingUploadAgreementSuccess
      );

      if (bookingCancelSuccess) {
        closeCancelModal();
      } else if (bookingUploadAgreementSuccess) {
        setStep(0);
        setIsAccepted(false);
        setShowScrollTop(false);
        clearSignature();
      } else {
        closeModal();
      }
    } else if (
      bookingsError ||
      bookingUploadLicenseError ||
      bookingUploadAgreementError
    ) {
      showToast(
        bookingsError ||
        bookingUploadLicenseError ||
        bookingUploadAgreementError
      );

      if (bookingUploadAgreementError) {
        setStep(0);
        setIsAccepted(false);
        setShowScrollTop(false);
        clearSignature();
      }

      closeModal();
    } else if (bookingCancelError) {
      showToast(bookingCancelError);
      closeCancelModal();
    }
    dispatch(resetBooking());
  }, [
    bookingsSuccess,
    bookingsError,
    bookingCancelError,
    bookingCancelSuccess,
    bookingUploadAgreementError,
    bookingUploadAgreementSuccess,
  ]);

  useEffect(() => {
    if (checkInCarImagesSuccess) {
      showToast(checkInCarImagesSuccess);
    } else if (checkInCarImagesError) {
      showToast(checkInCarImagesError);
    }
    dispatch(resetBooking());
  }, [checkInCarImagesSuccess, checkInCarImagesError]);

  const showToast = (message: any) => {
    setToastClass(
      bookingsError ||
        bookingUploadLicenseError ||
        bookingCancelError ||
        bookingUploadAgreementError ||
        checkInCarImagesError
        ? 'bg-danger text-white'
        : 'bg-success text-white'
    );
    setToastMessage(message);
  };

  useEffect(() => {
    if (bookingUploadLicenseSuccess) {
      showToast(bookingUploadLicenseSuccess);
    } else if (bookingUploadLicenseError) {
      showToast(bookingUploadLicenseError);
    }
  }, [bookingUploadLicenseSuccess, bookingUploadLicenseError]);

  type ContactFormValues = {
    name: string;
    email: string;
    message: string;
    phone: string;
    is_sms_alert_approved: boolean;
  };

  const ContactSchema = Yup.object().shape({
    name: Yup.string().required('Name is required'),
    email: Yup.string().email('Invalid email').required('Email is required'),
    message: Yup.string().required('Message is required'),
    phone: Yup.string().when('$phone', {
      is: (value: any) => value?.trim().length > 0, // Check if phone is not empty
      then: (schema) => schema.length(10, 'Phone must be exactly 10 digits'),
      otherwise: (schema) => schema.notRequired(), // Don't validate if empty
    }),
    is_sms_alert_approved: Yup.boolean().notRequired(),
  });

  const {
    register: contactRegister,
    handleSubmit: contactHandleSubmit,
    formState: { errors: contactErrors },
    reset: contactReset,
    // watch,
    // setValue,
    // trigger,
  } = useForm<ContactFormValues>({
    resolver: yupResolver(ContactSchema),
    defaultValues: {
      name: user?.name,
      email: user?.email,
      message: '',
      phone: user?.mobile,
      is_sms_alert_approved: false,
    },
  });

  const contactOnSubmit: SubmitHandler<ContactFormValues> = (data) => {
    const currentUrl = `${window.location.origin}${routes.listingDetails}/${carDetails?.vin}${location.search}`;
    dispatch(
      addContactUs({
        ...data,
        is_sms_alert_approved: data?.is_sms_alert_approved ? 1 : 0,
        query_type: 'enquiry',
        vehicle_id: carDetails?.id,
        ...(carDetails?.vehicle_current_status === 'Booked' && {
          start_date: formatDateWithTime(
            availabilityStartDate,
            availabilityFromTime
          ),
          end_date: formatDateWithTime(
            availabilityEndDate,
            availabilityUntilTime
          ),
          query_type: 'check_availability',
        }),
        fairental_message: `Hi Fairental team, we have a car enquiry from a customer ${data?.name}, ${data.phone}, ${data.email}, Enquiry :${data.message}, please click on the link to see the car details: ${currentUrl}`,
      })
    );

    const encodedMessage = encodeURIComponent(
      `Hi Fairental team, we have a car enquiry from a customer ${data?.name}, ${data.phone}, ${data.email}, Enquiry :${data.message}, please click on the link to see the car details: ${currentUrl}`
    );

    const value = {
      encodedMessage: encodedMessage,
      timestamp: new Date().getTime(),
      currentUrl: currentUrl,
    };

    sessionStorage.setItem('contactForm', JSON.stringify(value));
  };

  useEffect(() => {
    if (user) {
      contactReset({
        name: user.name ?? '',
        email: user.email ?? '',
        phone: user.mobile ?? '',
        message: '',
      });
    }
  }, [user, contactReset, contactUsSuccess]);

  useEffect(() => {
    if (contactUsSuccess) {
      showToast(contactUsSuccess);

      closeContactModal();
      dispatch(resetContactUs());
    } else if (contactUsError) {
      showToast(contactUsError);
      dispatch(resetContactUs());
    }
  }, [contactUsSuccess, contactUsError]);

  useEffect(() => {
    setFirst(1);

    const fromDate = dates?.[0] ? dates[0].toISOString().split('T')[0] : null;
    const toDate = dates?.[1] ? dates[1].toISOString().split('T')[0] : null;

    dispatch(
      getAllBooking({
        show_history: 1,
        itemsPerPage: 10,
        page: 1,
        status: activeStatus,
        from_date: fromDate,
        to_date: toDate,
        search: debouncedSearch,
      })
    );
  }, [dates, activeStatus, debouncedSearch]);

  useEffect(() => {
    dispatch(
      getActiveBooking({
        show_active: 1,
        itemsPerPage: 10,
        page: 1,
      })
    );
  }, []);

  useEffect(() => {
    dispatch(
      getPendingBooking({
        show_pending: 1,
        itemsPerPage: 10,
        page: 1,
      })
    );
  }, []);

  const pickupLocation = (res: any) => {
    return (
      <p
        className="text-wrap"
        data-bs-toggle="modal"
        onClick={() => {
          viewBooking(res?.id);
        }}
        data-bs-target="#view_booking"
      >
        {res?.pickup_location}
      </p>
    );
  };

  const BookingId = (res: any) => {
    return (
      <>
        <p
          data-bs-toggle="modal"
          onClick={() => {
            viewBooking(res?.id);
          }}
          data-bs-target="#view_booking"
          className="bookbyid"
        >
          #{res?.booking_id}
        </p>

        <p
          className="text-wrap"
          data-bs-toggle="modal"
          onClick={() => {
            viewBooking(res?.id);
          }}
          data-bs-target="#view_booking"
        >
          {res?.vehicle_name}
        </p>

        {res?.child_id && (
          <p className="badge bg-success-subtle text-success">Swapped and closed</p>
        )}
      </>
    );
  };

  const BookedOn = (res: any) => {
    if (!res?.booked_on) return <p>--</p>;

    const [datePart] = res.booked_on.split('T');
    const [year, month, day] = datePart.split('-').map(Number);

    const localDate = new Date(year, month - 1, day);

    const formattedDate = localDate.toLocaleDateString('en-US', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    });

    return <>{formattedDate}</>;
  };

  const SetDate = (date: string, time: string) => {
    if (!date && !time) return <p>--</p>;

    const [year, month, day] = date.split('-').map(Number);
    const [hours, minutes] = time.split(':').map(Number); // hh:mm

    const localDate = new Date(year, month - 1, day, hours, minutes);

    const formatted = localDate.toLocaleString('en-US', {
      day: '2-digit',
      month: 'short',
      year: '2-digit',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    });

    return <>{formatted}</>;
  };

  const TripStartDate = (res: any) => {
    return (
      <p
        data-bs-toggle="modal"
        onClick={() => {
          viewBooking(res?.id);
        }}
        data-bs-target="#view_booking"
      >
        {SetDate(res?.booking_start_date, res?.booking_start_time)}
      </p>
    );
  };

  const TripEndDate = (res: any) => {
    return (
      <p
        data-bs-toggle="modal"
        onClick={() => {
          viewBooking(res?.id);
        }}
        data-bs-target="#view_booking"
      >
        {SetDate(res?.booking_return_date, res?.booking_return_time)}
      </p>
    );
  };

  const CartStartTripDate = (res: any) => {
    return (
      <p
        className="text-wrap"
        data-bs-toggle="modal"
        onClick={() => {
          viewBooking(res?.id);
        }}
        data-bs-target="#view_booking"
      >
        {SetDate(res?.start_date, res?.start_time)}
      </p>
    );
  };

  const CartEndTripDate = (res: any) => {
    return (
      <p
        className="text-wrap"
        data-bs-toggle="modal"
        onClick={() => {
          viewBooking(res?.id);
        }}
        data-bs-target="#view_booking"
      >
        {SetDate(res?.return_date, res?.return_time)}
      </p>
    );
  };

  const PaymentUpfront = (res: any) => {
    return (
      <p
        data-bs-toggle="modal"
        onClick={() => {
          viewBooking(res?.id);
        }}
        data-bs-target="#view_booking"
        className="bookbyid"
      >
        Payment Upfront: <b>${res?.cost_summary?.initialPayment}</b>
      </p>
    );
  };

  const RefundAmount = (res: any) => {
    return res?.booking_refund ? (
      <p
        data-bs-toggle="modal"
        onClick={() => {
          viewBooking(res?.id);
        }}
        data-bs-target="#view_booking"
        className="bookbyid text-wrap"
      >
        Refund Amount: <b> ${res?.booking_refund?.refund_amount}</b> <br />
        {res?.booking_refund?.refund_notes && (
          <span className="text-danger">
            {' '}
            {' (' + res?.booking_refund?.refund_notes + ')'}
          </span>
        )}
      </p>
    ) : (
      ''
    );
  };

  const RefundMessage = (res: any) => {
    const getMessage = (status: any): string | null => {
      switch (status) {
        case 'under_review':
          return 'Your cancellation is under review. Refund will be processed soon.';
        case 'refund_pending':
          return 'Your refund has been approved and will be processed within 3–4 business days.';
        case 'refund_completed':
          return 'Refund processed.';
        case 'refund_failed':
          return 'There was an issue processing your refund. Please contact support.';
        case 'no_refund':
        default:
          return null; // No message
      }
    };

    const message = getMessage(res.refund_status);

    return message ? (
      <div className="alert alert-info mb-0">{message}</div>
    ) : null;
  };

  // const FuturePayment = (res: any) => {
  //   return res?.cost_summary?.nextBillingCycle?.payment_amount ? (
  //     <p
  //       data-bs-toggle="modal"
  //       onClick={() => {
  //         viewBooking(res?.id);
  //       }}
  //       data-bs-target="#view_booking"
  //       className="bookbyid"
  //     >
  //       Future Payment: ${res?.cost_summary?.nextBillingCycle?.payment_amount}/
  //       {res?.cost_summary?.paymentMethod?.name}{' '}
  //     </p>
  //   ) : (
  //     'N/A'
  //   );
  // };

  const Expires = (res: any) => {
    if (!res?.token_expires_at) return <p>--</p>;

    // Split date and time
    const [datePart, timePart] = res.token_expires_at.split(' '); // e.g., "2025-07-02T13:45:00Z"
    const [year, month, day] = datePart.split('-').map(Number);

    let hours = 0;
    let minutes = 0;

    if (timePart) {
      const [h, m] = timePart.split(':');
      hours = Number(h);
      minutes = Number(m);
    }

    // Construct local date
    const localDate = new Date(year, month - 1, day, hours, minutes);

    const formattedDate = localDate.toLocaleString('en-US', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true, // change to false if you want 24hr format
    });

    return <p>{formattedDate}</p>;
  };

  const Status = (data: any) => {
    const res = data;

    return (
      <span
        data-bs-toggle="modal"
        onClick={() => {
          viewBooking(res?.id);
        }}
        data-bs-target="#view_booking"
        className={`${res?.status_name == 'pending'
          ? 'badge badge-light-warning'
          : res?.status_name == 'confirmed'
            ? 'badge badge-light-success'
            : res?.status_name == 'completed'
              ? 'badge badge-light-success'
              : res?.status_name == 'canceled'
                ? 'badge badge-light-danger'
                : res?.status_name == 'in_progress'
                  ? 'badge badge-light-secondary'
                  : res?.status_name == 'extended'
                    ? 'badge badge-light-warning'
                    : 'badge badge-light-info'
          } text-wrap text-start`}
      >
        {res?.status_display_name}
      </span>
    );
  };

  const vehicleDetails = (res: any) => {
    return (
      <>
        <p
          className="text-wrap"
          data-bs-toggle="modal"
          onClick={() => {
            viewBooking(res?.id);
          }}
          data-bs-target="#view_booking"
        >
          {' '}
          {res?.vehicle?.year_make_model}{' '}
        </p>
        <p
          className="text-wrap"
          data-bs-toggle="modal"
          onClick={() => {
            viewBooking(res?.id);
          }}
          data-bs-target="#view_booking"
        >
          {' '}
          {res?.vehicle?.year_make_model}{' '}
        </p>

        {/* <p > <span className="fw-bold">  VIN:  </span>  {res?.vehicle?.vin} </p>
            <p > <span className="fw-bold">  Plate Number:  </span>  {res?.vehicle?.plate_number} </p> */}
      </>
    );
  };

  const CartAction = () => {
    return (
      <a
        className="dropdown-item px-0 align-items-baseline"
        href={vehicleRecommendationList?.bookingUrl}
      >
        <i className="feather icon-eye pe-1" /> View
      </a>
    );
  };

  const closeConfirmModal = () => {
    const backdrop = document.querySelector('.modal-backdrop');
    const confirmModal = document.getElementById('confirm');
    if (confirmModal) {
      confirmModal.style.display = 'none';
      confirmModal.classList.remove('show', 'modal-open');
    }
    if (backdrop) {
      backdrop.remove();
    }
  };

  const onPage = (event: any) => {
    setFirst(event);
    window.scrollTo(0, 0);

    dispatch(
      getAllBooking({
        show_history: 1,
        itemsPerPage: event.rows,
        page: event,
        status: activeStatus,
        from_date: dates[0]?.toISOString(),
        to_date: dates[1]?.toISOString(),
        search: searchInput,
      })
    );
  };

  const signatureDataURL = signaturePad.current?.toDataURL('image/png');

  const getAttachmentStatus = (
    captured_type_1: any,
    captured_type_2: any,
    label: any
  ): string => {
    const attachments = bookingDetail?.bookingattachments || [];

    const matchingAttachments = attachments.filter(
      (att: any) =>
        [captured_type_1, captured_type_2].includes(att?.captured_type) &&
        att?.label === label &&
        att?.file_url
    );

    if (matchingAttachments.length === 0) {
      return 'not-uploaded';
    }

    return matchingAttachments
      .map(
        (att: any, index: any) =>
          `<img key="${index}" src="${att.file_url}" alt="${label} preview ${index + 1}" style="width: 300px; object-fit: cover; margin: 10px;" />`
      )
      .join('');
  };

  const getAttachmentVehicle = (imgURL: any): string => {
    return `<img src="${imgURL}" alt="${imgURL} preview" style="width: 300px;  object-fit: cover; margin: 10px;" />`;
  };

  const bookingData = useMemo(
    () => ({
      logo: '<img class="img-fluid" src="/assets/img/logo/fairRentallogo-small.png" alt="Logo" style="width: 35%;">',
      startDate:
        dayjs(bookingDetail?.booking_start_date).format('MM-DD-YYYY') +
        ' ' +
        dayjs(bookingDetail?.booking_start_time, 'HH:mm:ss').format('HH:mm'),
      endDate:
        dayjs(bookingDetail?.booking_return_date).format('MM-DD-YYYY') +
        ' ' +
        dayjs(bookingDetail?.booking_return_time, 'HH:mm:ss').format('HH:mm'),

      bookingPrice: `${bookingDetail?.cost_summary?.pricePerDay}${bookingDetail?.cost_summary?.paymentMethod?.name === 'Daily'
          ? '/Day'
          : bookingDetail?.cost_summary?.paymentMethod?.name === 'Weekly'
            ? '/Week'
            : '/Full'
        }`,

      rentalPlan: bookingDetail?.cost_summary?.paymentMethod?.name,
      securityDeposit: `${bookingDetail?.cost_summary?.feeTypes?.find((item: any) => item.fee_type === 'Security Deposit')?.calcAmount}
    ${bookingDetail?.cost_summary?.feeTypes?.find(
        (item: any) => item.fee_type === 'Security Deposit'
      )?.reason
          ? ' (' +
          bookingDetail?.cost_summary?.feeTypes?.find(
            (item: any) => item.fee_type === 'Security Deposit'
          )?.reason +
          ')'
          : ''
        }`,
      includedDistance: 'Unlimited miles',
      pickupLocation: systemSettings?.default_pickup_location,
      protectionPlan: 'Default',
      plateNumber: bookingDetail?.vehicle?.plate_number,
      make: bookingDetail?.vehicle?.make,
      model: bookingDetail?.vehicle?.model,
      vin: bookingDetail?.vehicle?.vin,
      year: bookingDetail?.vehicle?.year,
      color: bookingDetail?.vehicle?.color,
      mileage: bookingDetail?.checkin?.odometer,
      fuelType: bookingDetail?.vehicle?.fuel_type,
      driverName: bookingDetail?.user?.last_name
        ? bookingDetail?.user?.first_name + ' ' + bookingDetail?.user?.last_name
        : bookingDetail?.user?.first_name,

      signature: signaturePad.current?.isEmpty()
        ? `<img src="${bookingDetail?.bookingattachments?.filter((att: any) =>
          ['signature'].some((keyword) =>
            att?.name?.toLowerCase().includes(keyword.toLowerCase())
          )
        )?.[0]?.file_url || []
        }" style="width: 50px;" />`
        : `<img src="${signatureDataURL}" style="width: 50px;" />`,
      selfie: getAttachmentStatus('selfie', '', 'driving_license'),
      license: getAttachmentStatus('upload', '', 'driving_license'),

      checkinCarImage: getAttachmentStatus('upload', '', 'checkin_car_image'),

      approveDate: dayjs().format('MM-DD-YYYY'),
      payment_model: bookingDetail?.payment_model,

      addressProof: getAttachmentStatus('upload', '', 'address_proof'),
      internalpictures: getAttachmentStatus(
        'capture',
        'upload',
        'checkin_internal_picture'
      ),
      externalpictures: getAttachmentStatus(
        'capture',
        'upload',
        'checkin_external_picture'
      ),
      odometerpictures: getAttachmentStatus(
        'capture',
        'upload',
        'checkin_odometer_picture'
      ),
      underhoodpictures: getAttachmentStatus(
        'capture',
        'upload',
        'checkin_underhood_picture'
      ),

      oilchangestickerpictures: getAttachmentStatus(
        'capture',
        'upload',
        'checkin_oilchange_sticker_picture'
      ),
      registrationstickerpictures:
        getAttachmentStatus(
          'capture',
          'upload',
          'checkin_registration_sticker_picture'
        ) ?? getAttachmentVehicle(carDetail?.registration_sticker),
      tollstickerpictures:
        getAttachmentStatus(
          'capture',
          'upload',
          'checkin_toll_sticker_picture'
        ) ?? getAttachmentVehicle(carDetail?.toll_picture),
      sparetyrepictures:
        getAttachmentStatus(
          'capture',
          'upload',
          'checkin_spare_tyre_picture'
        ) ?? getAttachmentVehicle(carDetail?.spare_tyre_picture),

      selfieClass:
        getAttachmentStatus('selfie', '', 'driving_license') === 'not-uploaded'
          ? 'not-uploaded'
          : '',
      licenseClass:
        getAttachmentStatus('upload', '', 'driving_license') === 'not-uploaded'
          ? 'not-uploaded'
          : '',
      addressProofClass:
        getAttachmentStatus('upload', '', 'address_proof') === 'not-uploaded'
          ? 'not-uploaded'
          : '',
      internalpicturesClass:
        getAttachmentStatus('capture', 'upload', 'checkin_internal_picture') ===
          'not-uploaded'
          ? 'not-uploaded'
          : '',
      externalpicturesClass:
        getAttachmentStatus('capture', 'upload', 'checkin_external_picture') ===
          'not-uploaded'
          ? 'not-uploaded'
          : '',
      odometerpicturesClass:
        getAttachmentStatus('capture', 'upload', 'checkin_odometer_picture') ===
          'not-uploaded'
          ? 'not-uploaded'
          : '',
      underhoodpicturesClass:
        getAttachmentStatus(
          'capture',
          'upload',
          'checkin_underhood_picture'
        ) === 'not-uploaded'
          ? 'not-uploaded'
          : '',
      oilchangestickerpicturesClass:
        getAttachmentStatus(
          'capture',
          'upload',
          'checkin_oilchange_sticker_picture'
        ) === 'not-uploaded'
          ? 'not-uploaded'
          : '',
      registrationstickerpicturesClass:
        getAttachmentStatus(
          'capture',
          'upload',
          'checkin_registration_sticker_picture'
        ) === 'not-uploaded'
          ? 'not-uploaded'
          : carDetail?.registration_sticker !== undefined
            ? 'not-uploaded'
            : '',
      tollstickerpicturesClass:
        getAttachmentStatus(
          'capture',
          'upload',
          'checkin_toll_sticker_picture'
        ) === 'not-uploaded'
          ? 'not-uploaded'
          : carDetail?.toll_picture !== undefined
            ? 'not-uploaded'
            : '',
      sparetyrepicturesClass:
        getAttachmentStatus(
          'capture',
          'upload',
          'checkin_spare_tyre_picture'
        ) === 'not-uploaded'
          ? 'not-uploaded'
          : carDetail?.spare_tyre_picture === undefined
            ? 'not-uploaded'
            : '',

      checkinCarImageClass:
        getAttachmentStatus('upload', '', 'checkin_car_image') ===
          'not-uploaded'
          ? 'not-uploaded'
          : '',

    }),
    [signRef, signatureDataURL, bookingDetail, carDetail, systemSettings, user]
  );

  const BookingAgreement: React.FC = () => {
    const replacePlaceholders = (
      template: string,
      data: Record<string, any>
    ) => {
      return template?.replace(/\{(\w+)\}/g, (_, key) => {
        return data[key] || 'N/A';
      });
    };

    const filledContent = replacePlaceholders(
      templateList?.find((item: any) => item.slug === 'preliminary_contract')
        ?.content,
      bookingData
    );

    return <div dangerouslySetInnerHTML={{ __html: filledContent }} />;
  };

  const handleCloseToast = () => {
    setToastMessage('');
  };

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const getParam = (key: string) => {
    const value = queryParams.get(key);
    return value ? decodeURIComponent(value) : '';
  };

  useEffect(() => {
    const bookingList = [
      ...(Array.isArray(userActiveBookings) ? (userActiveBookings ?? []) : []),
      ...(Array.isArray(userBookings) ? (userBookings ?? []) : []),
      ...(Array.isArray(userPendingBookings)
        ? (userPendingBookings ?? [])
        : []),
    ];

    if (bookingList) {
      const data = bookingList?.find(
        (item: any) => item?.id?.toString() === getParam('bookingId')
      );

      if (data) {
        setBooking(data);
        // dispatch(resetPasswordAuthenticate());

        if (
          getParam('licensePending') === '0' &&
          (data?.license_status === 'pending' ||
            data?.license_status === 'rejected')
        ) {
          const LicenseModal = document.getElementById(
            'upload_license_with_address_proof'
          );

          if (LicenseModal && LicenseModal.style.display !== 'block') {
            LicenseModal.style.display = 'block';
            LicenseModal.classList.add('show', 'modal-open');

            const backdrop = document.createElement('div');
            backdrop.className = 'modal-backdrop fade show';
            document.body.appendChild(backdrop);
            document.body.classList.add('modal-open');
            document.body.style.overflow = 'hidden';
            document.body.style.paddingRight = '0px';
          }
        } else if (
          getParam('paymentPending') === '0' &&
          (data?.payment_status === 'pending' ||
            data?.payment_status === 'rejected')
        ) {
          const PaymentPendingModal = document.getElementById('make_payment');

          if (
            PaymentPendingModal &&
            PaymentPendingModal.style.display !== 'block'
          ) {
            setBooking(data);

            PaymentPendingModal.style.display = 'block';
            PaymentPendingModal.classList.add('show', 'modal-open');

            const backdrop = document.createElement('div');
            backdrop.className = 'modal-backdrop fade show';

            document.body.appendChild(backdrop);
            document.body.classList.add('modal-open');
            document.body.style.overflow = 'hidden';
            document.body.style.paddingRight = '0px';
          }
        }
      }
    }
  }, [userActiveBookings, userBookings]);

  useEffect(() => {
    if (toastMessage) {
      if (toastClass === 'bg-danger text-white') {
        toast.error(toastMessage, {
          position: 'top-right',
          hideProgressBar: true,
          onClose: handleCloseToast,
          progress: undefined,
          toastId: '',
        });
      } else {
        toast.success(toastMessage, {
          position: 'top-right',
          hideProgressBar: true,
          onClose: handleCloseToast,
          progress: undefined,
          toastId: '',
        });
      }
    }
  }, [toastMessage, toastClass]);

  const steps = [
    {
      label: 'Verification Documents',
      icon: 'fa fa-id-card',
      status: 'license_status',
    },
    // {
    //   label: 'Application Review',
    //   icon: 'fas fa-file-alt',
    //   status: 'application_review_status',
    // },
    { label: 'Payment', icon: 'fa fa-credit-card', status: 'payment_status' },
    {
      label: 'Insurance',
      icon: 'fa fa-shield-alt',
      status: 'insurance_status',
    },

    {
      label: 'Check In',
      icon: 'fa fa-file-signature',
      status: 'checkin',
    },
  ];

  type StatusStepProps = {
    bookings: any;
  };

  const StatusStep: React.FC<StatusStepProps> = ({ bookings }) => {
    const dataBsTargetMap = {
      license_status: '#upload_license_with_address_proof',
      application_review_status: '#',
      payment_status: '#make_payment',
      insurance_status: '#view_insurance',
      checkin: '#',
    };

    const calculatedActiveStep = steps.findIndex((step) => {
      const status = bookings?.[step?.status];
      const isApproved = status === 'approved';
      if (isApproved) return false;

      if (['license_status', 'payment_status'].includes(step.status))
        return true;

      if (step.status === 'license_selfie_with_car_status') {
        return ['license_status', 'payment_status'].every(
          (s) => bookings?.[s] === 'approved'
        );
      }

      if (step.status === 'insurance_status') {
        return bookings?.['license_selfie_with_car_status'] === 'approved';
      }

      if (step.status === 'checkin') {
        return bookings?.['checkin'] === 'approved';
      }

      return false;
    });

    function getStepMessage(step: any, data: any) {
      switch (step) {
        case 'license_status':
          // if (
          //   data.license_status !== 'rejected' &&
          //   data.address_proof_status !== 'rejected'
          // )
          return (
            <>
              <p className="text-wrap mt-1">
                {progressMessages['verification_documents'] &&
                  progressMessages['verification_documents']['license'][
                  data.license_status
                  ]}
              </p>
              <p className="text-wrap">
                {progressMessages['verification_documents'] &&
                  progressMessages['verification_documents']['address_proof'][
                  data.address_proof_status
                  ]}
              </p>

              <p className="text-wrap">
                {progressMessages['verification_documents'] &&
                  progressMessages['verification_documents']['agreement'][
                  data.agreement_status
                  ]}
              </p>
            </>
          );

          // if (
          //   data.license_status === 'rejected' &&
          //   data.address_proof_status === 'rejected'
          // ) {
          //   const Items = data.bookingattachments?.filter(
          //     (item: any) =>
          //       item.label === 'driving_license' ||
          //       item.label === 'address_proof'
          //   );

          //   return (
          //     <ul className="  m-0 ps-3">
          //       {Items?.map((item: any, index: number) => (
          //         <li key={index} className="d-flex align-items-center">
          //           {' '}
          //           {index + 1}. <a href={item.file_url}> {item.name} </a>
          //           <br />{' '}
          //           <span className="fw-bold">
          //             {' '}
          //             {item.reject_reason ?? item.approve_reason}
          //           </span>
          //         </li>
          //       ))}
          //     </ul>
          //   );
          // }

          break;

        case 'application_review_status':
          return (
            <div>
              <p className="pt-1 text-wrap">
                License Status:{' '}
                <span className="fw-bold">
                  {data.license_status
                    ? data.license_status.charAt(0).toUpperCase() +
                    data.license_status.slice(1).toLowerCase()
                    : 'Pending'}{' '}
                </span>
              </p>
              <p className="text-wrap">
                {' '}
                Address Proof Status:{' '}
                <span className="fw-bold">
                  {' '}
                  {data.address_proof_status
                    ? data.address_proof_status.charAt(0).toUpperCase() +
                    data.address_proof_status.slice(1).toLowerCase()
                    : 'Pending'}{' '}
                </span>
              </p>{' '}
            </div>
          );

        case 'payment_status':
          return (
            <p className="text-wrap">
              {progressMessages['payment'] &&
                progressMessages['payment'][data.payment_status]}
            </p>
          );

          break;

        case 'insurance_status':
          return (
            <>
              <p className="text-wrap mt-1">
                {progressMessages['insurance'] &&
                  progressMessages['insurance'][data.insurance_status]}
              </p>
              {data.insurance_status === 'confirmed' &&
                data.bookingattachments?.find(
                  (item: any) => item.label === 'insurance'
                )?.file_url && (
                  <a
                    className="text-decoration-underline text-primary"
                    onClick={() => {
                      downloadFile(
                        data.bookingattachments?.find(
                          (item: any) => item.label === 'insurance'
                        )?.file_url,
                        'insurance'
                      );
                    }}
                    target="_blank"
                    rel="noopener noreferrer"
                    download
                  >
                    Download Insurance
                  </a>
                )}
              {data.insurance_info_required === 1 && (
                <span className="text-danger text-wrap">
                  {data.insurance_admin_notes}
                </span>
              )}
            </>
          );

        case 'checkin':
          return (
            <>
              <p className="text-wrap mt-1">
                {progressMessages['check_in'] &&
                  progressMessages['check_in']['selfie_with_car'][
                  data.license_selfie_with_car_status
                  ]}
              </p>

              <p>
                {progressMessages['check_in'] &&
                  progressMessages['check_in']['final_agreement']?.[
                  data?.final_agreement_status
                  ]}
              </p>

              {data?.final_agreement_status === 'approved' && (
                <a
                  className="text-decoration-underline text-primary"
                  onClick={() => {
                    downloadFile(
                      data.bookingattachments?.find(
                        (item: any) => item.label === 'final_agreement'
                      )?.file_url,
                      'final_agreement'
                    );
                  }}
                  target="_blank"
                  rel="noopener noreferrer"
                  download
                >
                  Download Final Agreement
                </a>
              )}
            </>
          );

          break;

        default:
          return <> </>;
      }
    }

    return (
      <Stepper
        activeStep={calculatedActiveStep}
        orientation="vertical"
        sx={{
          width: '100%',
          '& .MuiStepLabel-label': {
            fontFamily: 'GT Walsheim Trial Rg',
          },
        }}
      >
        {steps?.map((step, index) => {
          const status =
            step?.status === 'license_status'
              ? bookings?.license_status === 'approved' &&
                bookings?.address_proof_status === 'approved'
                ? 'approved'
                : 'pending'
              : step?.status === 'application_review_status'
                ? bookings?.license_status === 'approved' &&
                  bookings?.address_proof_status === 'approved'
                  ? 'approved'
                  : 'pending'
                : step?.status === 'insurance_status'
                  ? bookings?.insurance_status === 'confirmed'
                    ? 'approved'
                    : 'pending'
                  : step?.status === 'checkin'
                    ? bookings?.final_agreement_status === 'approved' &&
                      bookings?.license_selfie_with_car_status === 'approved'
                      ? 'approved'
                      : 'pending'
                    : bookings?.[step?.status];

          const isApproved = status === 'approved';
          const completed = isApproved;
          const dataBsTarget = dataBsTargetMap?.[step.status] || '';

          return (
            <Step key={index} completed={completed}>
              <StepLabel
                icon={
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px',
                    }}
                  >
                    <input
                      type="checkbox"
                      checked={completed}
                      readOnly
                      onClick={() => {
                        // viewBooking(bookings?.id);
                        if (
                          (bookings?.final_agreement_review_enabled === 1 &&
                            bookings?.final_agreement_status === 'pending') ||
                          step.status === 'checkin'
                        ) {
                          dispatch(
                            getFinalAgreementChecklist({
                              bookingId: bookings?.id,
                            })
                          );

                          dispatch(
                            getVehicleByVin({
                              vin: bookings?.vehicle?.vin,
                              from_date: formatDateWithTime(
                                bookingDetail?.booking_start_date,
                                bookingDetail?.booking_start_time
                              ),
                              to_date: formatDateWithTime(
                                bookingDetail?.booking_return_date,
                                bookingDetail?.booking_return_time
                              ),
                            })
                          );

                          dispatch(
                            getCheckInImage({ bookingId: bookings?.id })
                          );

                          // openModal();
                          // clearSignature();
                        }
                      }}
                      style={{
                        cursor: 'pointer',
                        width: '18px',
                        height: '18px',
                      }}
                    />
                  </div>
                }
              >
                <Typography>
                  <p
                    // {...(bookings?.[step.status] && ["pending", "rejected"].includes(

                    //   bookings?.[step.status] === 'license_status' ? ['license_status', 'address_proof_status'] : bookings?.[step.status]

                    // ) && {
                    //   "data-bs-toggle": "modal",
                    //   "data-bs-target": dataBsTarget,
                    // })}

                    // onClick={() => {
                    //   // viewBooking(bookings?.id);
                    //   if (bookings?.final_agreement_review_enabled === 1 && bookings?.final_agreement_status === "pending") {
                    //     dispatch(getFinalAgreementChecklist({
                    //       bookingId: bookings?.id
                    //     }));
                    //     clearSignature();
                    //   }
                    // }}
                    className={`mb-0 d-flex gap-3 align-items-center ${completed ? ' fw-bold' : ''} `}
                  >
                    <span>
                      {' '}
                      {step.status === 'final_agreement_status' &&
                        bookings?.final_agreement_review_enabled === 1
                        ? 'Final Agreement'
                        : step.label}{' '}
                    </span>

                    {/* <FaInfo
                        className="ms-1 text-primary"
                        data-tooltip-id="info-tooltip"
                        data-tooltip-content={bookings?.[step.status]?.toUpperCase()}
                        style={{
                          // color: "#007bff",
                          fontSize: "12px",
                          cursor: "pointer",
                          outline: "none",
                        }}
                        tabIndex={0}
                        onFocus={(e) => (e.currentTarget.style.outline = "none")}
                      /> */}

                    {/* /* bookings?.[step.status] === "license_status" && ** */}

                    {(step.status === 'license_status'
                      ? ['pending', 'rejected'].includes(
                        bookings.license_status
                      ) ||
                      ['pending', 'rejected'].includes(
                        bookings.address_proof_status
                      )
                      : step.status === 'payment_status'
                        ? ['pending', 'rejected'].includes(
                          bookings?.[step.status]
                        )
                        : step.status === 'checkin'
                          ? [
                            'approved',
                            'pending_admin_action',
                            'submitted',
                          ].includes(bookings?.final_agreement_status) &&
                            [
                              'approved',
                              'pending_admin_action',
                              'submitted',
                            ].includes(bookings?.license_selfie_with_car_status)
                            ? false
                            : true
                          : ['pending', 'rejected'].includes(
                            bookings?.[step.status]
                          )) && (
                        <>
                          <i
                            onClick={() => {
                              viewBooking(bookings?.id);
                              setBooking(bookings);
                              // clearSignature();
                              setIsAccepted(false);
                              setShowScrollTop(false);
                              if (
                                (bookings?.final_agreement_review_enabled === 1 &&
                                  bookings?.final_agreement_status ===
                                  'pending') ||
                                step.status === 'checkin'
                              ) {
                                dispatch(
                                  getFinalAgreementChecklist({
                                    bookingId: bookings?.id,
                                  })
                                );

                                dispatch(
                                  getVehicleByVin({
                                    vin: bookings?.vehicle?.vin,
                                    from_date: formatDateWithTime(
                                      bookingDetail?.booking_start_date,
                                      bookingDetail?.booking_start_time
                                    ),
                                    to_date: formatDateWithTime(
                                      bookingDetail?.booking_return_date,
                                      bookingDetail?.booking_return_time
                                    ),
                                  })
                                );
                              }

                              if (step.status === 'checkin') {
                                openModal();
                                dispatch(
                                  getCheckInImage({ bookingId: bookings?.id })
                                );
                              }
                            }}
                            className={`${step.status === 'payment_status' ? step.icon : 'fa fa-upload'} text-primary`}
                            style={{ fontSize: '12px' }}
                            {...(step.status !== 'checkin' && {
                              'data-bs-toggle': 'modal',
                              'data-bs-target': dataBsTarget,
                            })}
                          />
                        </>
                      )}

                    {step.status === 'license_status' &&
                      ['pending', 'rejected'].includes(
                        bookings?.agreement_status
                      ) && (
                        <>
                          <i
                            onClick={() => {
                              viewBooking(bookings?.id);
                              setBooking(bookings);
                              clearSignature();
                            }}
                            className={`fa fa-file-signature text-primary`}
                            style={{ fontSize: '12px' }}
                            {...(step.status === 'license_status' && {
                              'data-bs-toggle': 'modal',
                              'data-bs-target': '#preliminary_agreement',
                            })}
                          />
                        </>
                      )}
                    <Tooltip id="info-tooltip" place="top" />
                  </p>

                  {getStepMessage(step.status, bookings) && (
                    <p className="fs-12 align-items-center">
                      {getStepMessage(step.status, bookings)}{' '}
                    </p>
                  )}
                </Typography>
              </StepLabel>
              <StepContent />
            </Step>
          );
        })}

        {bookings?.payment_status === 'approved' && (
          <>
            {' '}
            {bookings?.vehicle?.registration_sticker ? (
              <a
                className="btn btn-primary text-white text-center border-1"
                download
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => {
                  downloadFile(
                    bookings?.vehicle?.registration_sticker,
                    'registration_sticker'
                  );
                }}
              >
                <i
                  className="fas fa-download me-2"
                  style={{ cursor: 'pointer' }}
                />
                Registration Sticker
              </a>
            ) : (
              ''
            )}{' '}
          </>
        )}
      </Stepper>
    );
  };

  const checkinRef = useRef(null);
  let modalInstance = null;

  const openModal = () => {
    if (checkinRef.current) {
      modalInstance = new Modal(checkinRef.current);
      modalInstance.show();
    }
  };

  const closeCheckinModal = () => {
    if (checkinRef.current) {
      setStep(0);
      modalInstance = Modal.getInstance(checkinRef.current);
      modalInstance?.hide();
    }

    const backdrop = document.querySelector('.modal-backdrop');

    if (backdrop) {
      backdrop.remove();
    }
  };

  // const downloadFile = (url: string) => {
  //   // Extract the extension from the URL
  //   const urlParts = url.split('?')[0].split('/');
  //   const originalFileName = urlParts[urlParts.length - 1];
  //   const extensionMatch = originalFileName.match(/\.[^/.]+$/); // matches `.jpg`, `.png`, etc.

  //   const extension = extensionMatch ? extensionMatch[0] : '';
  //   const fileName = `registration_sticker${extension}`;

  //   const link = document.createElement('a');
  //   link.href = url;
  //   link.download = fileName;
  //   document.body.appendChild(link);
  //   link.click();
  //   document.body.removeChild(link);
  // };

  const downloadFile = async (fileUrl: string, name: string) => {
    try {
      const response = await fetch(fileUrl);
      const blob = await response.blob();

      // Get original file extension
      const urlParts = fileUrl.split('?')[0].split('/');
      const originalFileName = urlParts[urlParts.length - 1];
      const extensionMatch = originalFileName.match(/\.[^/.]+$/);
      const extension = extensionMatch ? extensionMatch[0] : '';

      const fileName = `${name}${extension}`;
      downloadBlob(blob, fileName);
    } catch (error) {
      console.error('Failed to download file:', error);
    }
  };

  const downloadBlob = (blob: Blob, filename: string) => {
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  const handleSuccess = () => {
    // on successful booking
    closeCheckinModal();

    // optionally show another modal, toast, or update state
  };

  return (
    <>
      <DashboardMenu />
      <div className="content">
        <div className="container">
          <div className="row">
            {vehicleRecommendationLoading || bookingsLoading ? (
              <div className="d-flex justify-content-center align-items-center">
                <Lottie
                  animationData={Loader}
                  loop={true}
                  style={{ width: 300, height: 300 }}
                />
              </div>
            ) : (
              <>
                {/* All Bookings */}
                {activeStatus === null &&
                  activeBookings?.data?.length > 0 &&
                  activeBookings?.meta?.total_items > 0 && (
                    <>
                      <div className="col-lg-12 d-flex">
                        <div className="card book-card flex-fill mb-0">
                          <div className="card-header border-bottom-0 mt-0 pt-0 px-0">
                            <div className="row align-items-center">
                              <div className="col-8  col-md-5">
                                <h4 className="align-items-center mb-0">
                                  {' '}
                                  {'Active Booking'}
                                  {/* <span>{pendingBookings?.meta?.total_items}</span> */}
                                </h4>
                              </div>
                            </div>
                          </div>
                          <div className="card-body px-0">
                            <div className="table-responsive dashboard-booking-table dashboard-table dashboard-table-info">
                              <table className="table border">
                                <tbody>
                                  {userActiveBookings &&
                                    userActiveBookings?.map(
                                      (item: any, index: number) => {
                                        return (
                                          <tr key={index}>
                                            <td
                                              onClick={() => {
                                                viewBooking(item?.id);
                                              }}
                                              data-bs-toggle="modal"
                                              data-bs-target="#view_booking"
                                            >
                                              <div className="table-avatar">
                                                <Link
                                                  to={routes.userBookings}
                                                  className="avatar avatar-lg flex-shrink-0"
                                                >
                                                  <ImageWithBasePath
                                                    className="avatar-img"
                                                    src={
                                                      item?.vehicle
                                                        ?.primary_image
                                                    }
                                                    alt="Booking"
                                                  />
                                                </Link>
                                                <div className="table-head-name flex-grow-1">
                                                  <div className="table-avatar">
                                                    <div className="table-head-name flex-grow-1 mb-1">
                                                      <p className="mb-0">
                                                        {' '}
                                                        {
                                                          item?.vehicle
                                                            ?.year_make_model
                                                        }{' '}
                                                      </p>
                                                    </div>
                                                  </div>

                                                  <p className="mb-0">
                                                    Booking ID : #
                                                    {item.booking_id}
                                                  </p>

                                                  <p className="mb-0 text-wrap">
                                                    {' '}
                                                    {SetDate(
                                                      item?.booking_start_date,
                                                      item?.booking_start_time
                                                    )}{' '}
                                                    -{' '}
                                                    {SetDate(
                                                      item?.booking_return_date,
                                                      item?.booking_return_time
                                                    )}
                                                  </p>
                                                </div>
                                              </div>
                                            </td>

                                            <td
                                              className="w-50"
                                              onClick={() => {
                                                viewBooking(item?.id);
                                              }}
                                            >
                                              <Status {...item} />
                                            </td>
                                            {(item?.license_status === 'pending' ||
                                              item?.license_status === 'rejected') && (
                                                <td className="align-items-center w-100 w-md-50 text-wrap">
                                                  <a
                                                    href="#"
                                                    data-bs-toggle="modal"
                                                    data-bs-target="#upload_license_with_address_proof"
                                                    onClick={() => setBooking(item)}
                                                    className="badge bg-danger-subtle text-danger"
                                                  >
                                                    <i className="fas fa-id-card me-2" /> Upload License
                                                  </a>
                                                </td>
                                              )}
                                            {/* {item?.bookingattachments?.filter(
                                              (item: any) =>
                                                item.label === 'final_agreement'
                                            )?.length > 0 && (
                                              <td className="w-50 align-items-end">
                                                <a
                                                  className="dropdown-item "
                                                  href="#"
                                                  data-bs-toggle="modal"
                                                  data-bs-target="#view_attachment"
                                                  onClick={() => {
                                                    setBooking(item);
                                                    dispatch(
                                                      resetPasswordAuthenticate()
                                                    );
                                                  }}
                                                >
                                                  <i className="fa fa-paperclip me-2" />{' '}
                                                  Final Agreement
                                                </a>
                                              </td>
                                            )} */}

                                            {item?.bookingattachments?.filter(
                                              (item: any) =>
                                                (item.verification
                                                  ?.verification ===
                                                  'final_agreement' &&
                                                  item.verification
                                                    ?.approved === true) ||
                                                item.verification
                                                  ?.verification === 'agreement'
                                            )?.length > 0 && (
                                                <td className="w-50 align-items-end">
                                                  <a
                                                    href="#"
                                                    // className="text-wrap"
                                                    data-bs-toggle="modal"
                                                    data-bs-target="#view_attachment"
                                                    onClick={() => {
                                                      setBooking(item);
                                                      dispatch(
                                                        resetPasswordAuthenticate()
                                                      );
                                                    }}
                                                  >
                                                    <i className="fa fa-paperclip me-2" />{' '}
                                                    {item?.final_agreement_status ===
                                                      'approved'
                                                      ? 'Final Agreement'
                                                      : 'Preliminary Contract'}
                                                  </a>
                                                </td>
                                              )}

                                            <td
                                              className={`${isMobile ? 'w-100' : 'w-50'}  text-wrap border-bottom-0`}
                                            >
                                              {item?.status_name !== 'pending' && item?.status_name !== 'in-progress' && (
                                                <div className="d-flex gap-2 my-2" style={{ width: " -webkit-fill-available" }}>
                                                  <Link
                                                    to="#"
                                                    data-bs-toggle="modal"
                                                    data-bs-target="#checkout"
                                                    className="btn btn-primary text-white py-1 flex-fill"
                                                    onClick={() => setBooking(item)}
                                                  >
                                                    End Rental
                                                  </Link>
                                                  {item?.show_extend_button && (
                                                    <Link
                                                      to="#"
                                                      className="btn btn-violet py-1 flex-fill"
                                                      onClick={() => handleOpenExtendModal(item)}
                                                    >
                                                      Extend Rental
                                                    </Link>
                                                  )}

                                                </div>
                                              )}

                                              <Link
                                                to="#"
                                                data-bs-toggle="modal"
                                                data-bs-target="#enquiry"
                                                className="btn btn-secondary w-100  text-white py-1 "
                                                onClick={() =>
                                                  setCarDetails(item?.vehicle)
                                                }
                                              >
                                                {' '}
                                                {'Get in touch'}
                                              </Link>
                                            </td>
                                          </tr>
                                        );
                                      }
                                    )}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  )}

                {activeStatus === null &&
                  pendingBookings?.data?.length > 0 &&
                  pendingBookings?.meta?.total_items > 0 && (
                    <>
                      <div className="col-lg-12 d-flex">
                        <div className="card book-card flex-fill mb-0">
                          <div className="card-header mt-0 pt-0 px-0">
                            <div className="row align-items-center">
                              <div className="col-8  col-md-5">
                                <h4 className="align-items-center mb-0">
                                  {'Pending Booking'}
                                </h4>
                              </div>
                            </div>
                          </div>
                          <div className="card-body px-0">
                            <div className="table-responsive dashboard-booking-table dashboard-table dashboard-table-info">
                              <table className="table">
                                <tbody>
                                  {userPendingBookings &&
                                    userPendingBookings?.map(
                                      (item: any, index: number) => {
                                        return (
                                          <tr key={index}>
                                            <td>
                                              <div className="table-avatar">
                                                <Link
                                                  to={routes.userBookings}
                                                  className="avatar avatar-lg flex-shrink-0"
                                                >
                                                  <ImageWithBasePath
                                                    className="avatar-img"
                                                    src={
                                                      item?.vehicle
                                                        ?.primary_image
                                                    }
                                                    alt="Booking"
                                                  />
                                                </Link>
                                                <div className="table-head-name flex-grow-1">
                                                  <div className="table-avatar">
                                                    <div className="table-head-name flex-grow-1 mb-1">
                                                      <p className="mb-0">
                                                        {' '}
                                                        {
                                                          item?.vehicle
                                                            ?.year_make_model
                                                        }{' '}
                                                      </p>
                                                    </div>
                                                  </div>

                                                  <p className="mb-0">
                                                    Booking ID : #
                                                    {item.booking_id}
                                                  </p>

                                                  <p className="mb-0 text-wrap">
                                                    {' '}
                                                    {SetDate(
                                                      item?.booking_start_date,
                                                      item?.booking_start_time
                                                    )}{' '}
                                                    -{' '}
                                                    {SetDate(
                                                      item?.booking_return_date,
                                                      item?.booking_return_time
                                                    )}
                                                  </p>

                                                  <p className="mb-0">
                                                    <Status {...item} />
                                                  </p>
                                                </div>
                                              </div>
                                            </td>

                                            <td className="w-100 text-wrap">
                                              <p className="mb-0">
                                                {' '}
                                                Following items to be completed.
                                                In order to start reservation
                                              </p>
                                            </td>

                                            <td className=" w-100">
                                              <StatusStep bookings={item} />
                                            </td>
                                          </tr>
                                        );
                                      }
                                    )}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  )}

                {activeStatus === null &&
                  cartBookings &&
                  cartBookings?.length > 0 && (
                    <>
                      <div className="col-lg-12">
                        <div className="card book-card flex-fill mb-0">
                          <div className="card-header border-bottom-0 mt-0 pt-0 px-0">
                            <div className="row align-items-center">
                              <div className="col-8  col-md-5">
                                <h4 className="align-items-center mb-0">
                                  {bookingStatusList &&
                                    activeStatus &&
                                    bookingStatusList.length > 0
                                    ? bookingStatusList
                                      .filter(
                                        (item: any) =>
                                          item.id === activeStatus
                                      )
                                      .map(({ name }: any) =>
                                        name
                                          ?.toLowerCase()
                                          .replace(/_/g, ' ') // Replace underscores with spaces
                                          .replace(/^\w/, (c: string) =>
                                            c.toUpperCase()
                                          )
                                      )
                                    : 'Booking Cart'}

                                  {/* <span>{cartBookings?.length}</span> */}
                                </h4>
                              </div>
                            </div>
                          </div>
                          <div className="card-body px-0">
                            <div className="table-responsive dashboard-table">
                              <DataTable
                                className="table datatable"
                                value={cartBookings || []}
                                stripedRows
                                // paginator
                                // rowsPerPageOptions={[10, 25, 50]}
                                // rows={rows}
                                // totalRecords={bookings?.meta?.total ?? 0}
                                // first={first}
                                // lazy
                                // onPage={onPage}
                                selectionMode="single"
                              >
                                <Column
                                  field="vehicle"
                                  header="Vehicle"
                                  body={vehicleDetails}
                                  className="w-50 w-md-10"
                                ></Column>
                                <Column
                                  field="Expires"
                                  header="Expires"
                                  body={Expires}
                                >
                                  {' '}
                                </Column>
                                <Column
                                  field="tripDate"
                                  header="Trip Date"
                                  body={CartStartTripDate}
                                >
                                  {' '}
                                </Column>
                                <Column
                                  field="tripDate"
                                  header="Trip Date"
                                  body={CartEndTripDate}
                                >
                                  {' '}
                                </Column>
                                <Column
                                  field="action"
                                  header="Action"
                                  className="border-bottom-0"
                                  body={CartAction}
                                ></Column>
                                <Column
                                  field=" "
                                  header=" "
                                  className="border-bottom-0"
                                  body={<></>}
                                ></Column>
                              </DataTable>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  )}

                {bookings?.meta?.total_items > 0 ? (
                  <div className="col-lg-12 d-flex">
                    <div className="card book-card flex-fill mb-0">
                      <div className="card-header border-bottom-0 mb-1 mt-0 pt-0 px-0">
                        <div className="row align-items-center">
                          <div className="col-8  col-md-5">
                            <h4 className="align-items-center mb-0">
                              {bookingStatusList &&
                                activeStatus &&
                                bookingStatusList.length > 0
                                ? bookingStatusList
                                  .filter(
                                    (item: any) => item.id === activeStatus
                                  )
                                  .map(({ name }: any) =>
                                    name
                                      ?.toLowerCase()
                                      .replace(/_/g, ' ') // Replace underscores with spaces
                                      .replace(/^\w/, (c: string) =>
                                        c.toUpperCase()
                                      )
                                  )
                                : 'Bookings History'}

                              <span>{bookings?.meta?.total_items ?? 0}</span>
                            </h4>
                          </div>

                          <div className="col-12 col-md-7 text-md-end d-none d-md-block">
                            <div className="row table-search">
                              <div
                                id="tablefilter"
                                className="col-12 col-md-4 me-md-0 pe-md-0"
                              >
                                <label className="d-flex">
                                  <input
                                    type="text"
                                    value={searchInput}
                                    onChange={(e) =>
                                      setSearchInput(e.target.value)
                                    }
                                    placeholder="Search"
                                    className="form-control inputsearch"
                                  />
                                </label>
                              </div>
                              <div className="col-12 col-md-3 ">
                                <Calendar
                                  className="bg-custom py-0"
                                  value={dates.length ? dates : []} // Ensure it's always an array
                                  onChange={(e: any) => setDates(e.value || [])} // Fallback to empty array
                                  placeholder="Choose Date Range"
                                  selectionMode="range"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="card-body px-0">
                        <div className="table-responsive dashboard-table">
                          <table className="table datatable">
                            <tbody>
                              {userBookings &&
                                bookings?.meta?.total_items > 0 ? (
                                userBookings?.map((res, index) => (
                                  <tr key={index}>
                                    <td className="w-50">{BookingId(res)}</td>
                                    <td className="w-50">
                                      {pickupLocation(res)}
                                    </td>
                                    <td className="w-100 w-md-50">
                                      {' '}
                                      {TripStartDate(res)}
                                    </td>
                                    <td className="w-100 w-md-50">
                                      {' '}
                                      {TripEndDate(res)}
                                    </td>
                                    <td className="w-100 w-md-50">
                                      {PaymentUpfront(res)}
                                    </td>

                                    <td className="w-100 w-md-50">
                                      {Status(res)}
                                    </td>

                                    {res?.booking_refund && (
                                      <td className=" w-100 text-wrap">
                                        {RefundAmount(res)}{' '}
                                      </td>
                                    )}

                                    {res.refund_status &&
                                      res.refund_status !== 'no_refund' && (
                                        <td className="w-100  text-wrap">
                                          {' '}
                                          {res.refund_status
                                            ? RefundMessage(res)
                                            : ''}
                                        </td>
                                      )}

                                    {res?.status_name !==
                                      'canceled_and_closed' &&
                                      res?.status_name !== 'canceled' &&
                                      (res?.license_status === 'pending' ||
                                        res?.license_status === 'rejected') && (
                                        <td className="align-items-center w-100 w-md-50 text-wrap">
                                          <a
                                            href="#"
                                            data-bs-toggle="modal"
                                            data-bs-target="#upload_license_with_address_proof"
                                            onClick={() => setBooking(res)}
                                          >
                                            <i className="fas fa-id-card me-2" />{' '}
                                            Upload Verification Documents
                                          </a>
                                        </td>
                                      )}

                                    {/* Sign Agreement */}
                                    {res?.status_name !==
                                      'canceled_and_closed' &&
                                      res?.status_name !== 'canceled' &&
                                      res?.agreement_status === 'pending' && (
                                        <td className="align-items-center w-100 w-md-50 text-wrap">
                                          <a
                                            href="#"
                                            data-bs-toggle="modal"
                                            data-bs-target="#preliminary_agreement"
                                            onClick={() => {
                                              viewBooking(res?.id);
                                              setIsAccepted(false);
                                              setShowScrollTop(false);
                                              dispatch(
                                                getFinalAgreementChecklist({
                                                  bookingId: res?.id,
                                                })
                                              );

                                              // clearSignature();
                                            }}
                                          >
                                            <i className="fas fa-file-signature me-2" />{' '}
                                            Sign Agreement
                                          </a>
                                        </td>
                                      )}

                                    {/* View Attachment */}
                                    {res?.status_name !==
                                      'canceled_and_closed' &&
                                      res?.status_name !== 'canceled' &&
                                      res?.bookingattachments?.filter(
                                        (item: any) =>
                                          (item.verification?.verification ===
                                            'final_agreement' &&
                                            item.verification?.approved ===
                                            true) ||
                                          item.verification?.verification ===
                                          'agreement'
                                      )?.length > 0 && (
                                        <td className="align-items-center w-100 w-md-50 text-wrap  text-left  ">
                                          <a
                                            href="#"
                                            // className="text-wrap"
                                            data-bs-toggle="modal"
                                            data-bs-target="#view_attachment"
                                            onClick={() => {
                                              setBooking(res);
                                              dispatch(
                                                resetPasswordAuthenticate()
                                              );
                                            }}
                                          >
                                            <i className="fa fa-paperclip me-2" />{' '}
                                            {res?.final_agreement_status ===
                                              'approved'
                                              ? 'Final Agreement'
                                              : 'Preliminary Contract'}
                                          </a>
                                        </td>
                                      )}

                                    {/* Make Payment */}
                                    {res?.status_name !== 'canceled_and_closed' &&
                                        res?.status_name !== 'canceled' &&
                                        res?.status_name !== 'returned' &&
                                        res?.payment_status === 'pending' && (
                                        <td className="align-items-center w-100 w-md-50 text-wrap ">
                                          <a
                                            href="#"
                                            data-bs-toggle="modal"
                                            data-bs-target="#make_payment"
                                            onClick={(event) =>
                                              handlePaymentClick(event, res)
                                            }
                                          >
                                            <i className="feather icon-credit-card me-2" />{' '}
                                            Make Payment
                                          </a>
                                        </td>
                                      )}

                                    {/* Cancel Booking */}
                                    {res?.status_name !==
                                      'canceled_and_closed' &&
                                      res?.status_name !== 'canceled' &&
                                      res?.status_name === 'pending' && (
                                        <td className="align-items-center w-100 w-md-50 text-wrap ">
                                          <a
                                            href="#"
                                            data-bs-toggle="modal"
                                            data-bs-target="#cancel_booking"
                                            onClick={() => setBooking(res)}
                                          >
                                            <i className="fas fa-calendar-times me-2" />{' '}
                                            Cancel Booking
                                          </a>
                                        </td>
                                      )}
                                  </tr>
                                ))
                              ) : (
                                <></>
                              )}
                            </tbody>
                          </table>

                          {bookings?.meta?.total_pages > 1 && (
                            <>
                              {' '}
                              <div className="d-flex justify-content-center justify-content-md-end p-2 my-2">
                                <Pagination
                                  currentPage={first || 1}
                                  totalPages={bookings?.meta?.total_items || 1}
                                  onPageChange={onPage}
                                />
                              </div>
                              <div className="table-footer">
                                <div className="row">
                                  <div className="col-md-6">
                                    <div id="tablelength" />
                                  </div>
                                  <div className="col-md-6 text-md-end">
                                    <div id="tablepage" />
                                  </div>
                                </div>
                              </div>{' '}
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                ) : bookings?.meta?.total_items === 0 &&
                  activeBookings?.meta?.total_items === 0 &&
                  pendingBookings?.meta?.total_items === 0 ? (
                  <div className="col-lg-12 d-flex">
                    <div className="card book-card flex-fill mb-0">
                      <div className="card-header border-bottom-0 mb-1 mt-0 pt-0 px-0">
                        <p>No reservation found</p>
                      </div>
                    </div>
                  </div>
                ) : (
                  ' '
                )}
              </>
            )}
          </div>
        </div>
      </div>

      {/* /Upcoming Booking */}

      <ViewBooking BookedOn={BookedOn} SetDate={SetDate} />
      <CancelBooking booking={booking} />
      <UploadLicense booking={booking} />
      <BookingAttachment booking={booking} />
      <Checkout booking={booking} />

      {!document
        .getElementById('preliminary_agreement')
        ?.classList.contains('show') && (
          <Checkin
            booking={booking}
            checkinRef={checkinRef}
            handleSuccess={handleSuccess}
            setStep={setStep}
            step={step}
            finalAgreementChecklist={finalAgreementChecklist}
            clearSignature={clearSignature}
            handleAccept={handleAccept}
            showScrollTop={showScrollTop}
            handleScroll={handleScroll}
            scrollToTop={scrollToTop}
            scrollToBottom={scrollToBottom}
            BookingAgreement={BookingAgreement}
            isAccepted={isAccepted}
            termsRef={termsRef}
            signRef={signRef}
            loading={bookingUploadAgreementLoading}
            setIsAccepted={setIsAccepted}
          />
        )}

      {!document.getElementById('checkin')?.classList.contains('show') && (
        <PreliminaryAgreement
          clearSignature={clearSignature}
          handleAccept={handleAccept}
          showScrollTop={showScrollTop}
          handleScroll={handleScroll}
          scrollToTop={scrollToTop}
          scrollToBottom={scrollToBottom}
          BookingAgreement={BookingAgreement}
          isAccepted={isAccepted}
          termsRef={termsRef}
          signRef={signRef}
          loading={bookingUploadAgreementLoading}
        />
      )}

      <ContactConfirm closeConfirmModal={closeConfirmModal} />

      {
        <div
          className="modal new-modal multi-step fade"
          id="make_payment"
          data-keyboard="false"
          data-backdrop="static"
          tabIndex={-1}
        >
          <div className="modal-dialog modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header mb-0 pb-0">
                <div className="mb-1">
                  <h6 className="text-nowrap fw-bold">Payment</h6>
                </div>
                <button
                  type="button"
                  className="close-btn"
                  data-bs-dismiss="modal"
                // onClick={() => {
                //   closePaymentModal();
                // }}
                >
                  <span>×</span>
                </button>
              </div>
              <div className="modal-body">
                {booking?.id ? (
                  <BookingPayment
                    // bookingId={selectedBookingId} initialPayment={initialPayment}
                    bookings={booking}
                    enquiry={'hide'}
                  />
                ) : (
                  <div className="d-flex justify-content-center align-items-center">
                    <Lottie
                      animationData={Loader}
                      loop={true}
                      style={{ width: 300, height: 300 }}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      }

      <div
        className="offcanvas offcanvas-end"
        tabIndex={33}
        id="offcanvasRight"
        aria-labelledby="offcanvasRightLabel"
      >
        <div className="offcanvas-header">
          <button
            type="button"
            className="btn-close text-reset"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
            onClick={() => {
              document.body.style.overflow = '';
              document.body.style.paddingRight = '';
            }}
          ></button>
        </div>
        <div className="offcanvas-body">
          <form
            // onSubmit={handleSubmit}
            action="#"
            autoComplete="off"
            className=""
          >
            <div className="row  ">
              <div id="tablefilter" className="col-12 col-md-5 me-md-0 pe-md-0">
                <label className="d-flex">
                  <input
                    type="text"
                    value={searchInput}
                    onChange={(e) => setSearchInput(e.target.value)}
                    placeholder="Search"
                    className="form-control inputsearch fs-13"
                  />
                </label>
              </div>

              <div className="col-12 col-md-6 ">
                <Calendar
                  className="  bg-custom py-2 fs-13"
                  value={dates.length ? dates : []} // Ensure it's always an array
                  onChange={(e: any) => setDates(e.value || [])} // Fallback to empty array
                  placeholder="Choose Date Range"
                  selectionMode="range"
                  style={{
                    fontSize: 10,
                  }}
                />
              </div>

              <div className="col-12 col-md-6 ">
                <label className="my-1 d-flex">
                  <select
                    className="form-select fs-13"
                    aria-label="Default select example"
                    onChange={(e) => setActiveStatus(parseInt(e.target.value))}
                  >
                    <option value="" className="fs-12">
                      Select Status
                    </option>
                    <option value="" className="fs-12">
                      Select Status
                    </option>
                    {bookingStatusList?.map(({ id, name }: any) => (
                      <option key={id} value={id} className="fs-12">
                        {name
                          ?.toLowerCase()
                          .replace(/_/g, ' ') // Replace underscores with spaces
                          .replace(/^\w/, (c: string) => c.toUpperCase())}{' '}
                      </option>
                    ))}
                  </select>
                </label>
              </div>

              <div className="col-12 mt-1 ">
                <button
                  type="button"
                  className="fs-13 d-inline-flex align-items-center justify-content-center btn btn-primary filter-btn"
                  data-bs-dismiss="offcanvas"
                  aria-label="Close"
                  onClick={() => {
                    document.body.style.overflow = '';
                    document.body.style.paddingRight = '';
                  }}
                >
                  <span style={{ marginTop: 1 }}>
                    <i className="feather icon-filter fs-12 me-2" />
                  </span>
                  Apply Filter
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>

      {toastMessage && <ToastContainer autoClose={3000} />}
      <div
        className={`modal fade ${isExtendModalOpen ? 'show d-block' : ''}`}
        id="extendBookingModal"
        tabIndex={-1}
        role="dialog"
        aria-labelledby="extendBookingModalLabel"
        aria-hidden={!isExtendModalOpen}
        style={{ display: isExtendModalOpen ? 'block' : 'none' }}
        data-bs-backdrop="static"
        data-bs-keyboard="false"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header p-3">
              <h5 className="modal-title" id="extendBookingModalLabel">Extend Booking</h5>
              <button type="button" className="btn-close" onClick={handleCloseExtendModal} aria-label="Close"></button>
            </div>
            <div className="modal-body">
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap' }}>
                  <div style={{ flex: '1 1 45%' }}>
                    <label className=" m-1">Select Date
                      {/* <Typography variant="body1">Select Date</Typography> */}
                      <DatePicker
                        className='datepickers'
                        value={extensionDate}
                        closeOnSelect={true}
                        onChange={(newValue) => {
                          setExtensionDate(newValue);
                          setIsDatePickerOpen(false);
                        }}
                        slotProps={{
                          textField: {
                            fullWidth: true,
                            onFocus: handleDatePickerFocus,
                            size: "small",
                            InputProps: {
                              sx: {
                                "& .MuiInputBase-input": {
                                  padding: "6px",
                                  textAlign: "center",
                                },
                              },
                            },
                          },
                          popper: {
                            open: isDatePickerOpen,
                          },
                        }}
                        minDate={dayjs()}
                      />
                    </label>
                  </div>
                  <div style={{ flex: '1 1 45%' }}>
                    <label className=" m-1">Select Time
                      {/* <Typography variant="body1">Select Time</Typography> */}
                      <TimePicker
                        className='datepickers'
                        value={extensionTime}
                        onAccept={() => setIsTimePickerOpen(false)}
                        onChange={(newValue) => setExtensionTime(newValue)}
                        slotProps={{
                          textField: {
                            fullWidth: true,
                            onFocus: handleTimePickerFocus,
                            size: "small",
                            InputProps: {
                              sx: {
                                "& .MuiInputBase-input": {
                                  padding: "6px",
                                  textAlign: "center",
                                },
                              },
                            },
                          },
                          popper: {
                            open: isTimePickerOpen,
                          },
                        }}
                      />
                    </label>
                  </div>
                </div>
              </LocalizationProvider>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={handleCloseExtendModal}
                disabled={extensionRequestLoading}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleExtendBooking}
                disabled={extensionRequestLoading || !extensionDate || !extensionTime}
              >
                {extensionRequestLoading ? (
                  <>
                    <Spinner size="sm" className="me-2" />
                    Submitting
                  </>
                ) : (
                  'Extend Booking'
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
      {isExtendModalOpen && <div className="modal-backdrop fade show" onClick={handleCloseExtendModal}></div>}
      <EnquiryForm
        carDetail={carDetails}
        handleSubmit={contactHandleSubmit}
        contactUsLoading={contactUsLoading}
        onSubmit={contactOnSubmit}
        register={contactRegister}
        errors={contactErrors}
        timeOptions={timeOptions}
        systemSettings={systemSettings}
        setShowCalendar={setShowCalendar}
        showCalendar={showCalendar}
        setStartDate={setAvailabilityStartDate}
        setEndDate={setAvailabilityEndDate}
        setFromTime={setAvailabilityFromTime}
        setUntilTime={setAvailabilityUntilTime}
        startDate={availabilityStartDate}
        endDate={availabilityEndDate}
        fromTime={availabilityFromTime}
        untilTime={availabilityUntilTime}
      />

      <ContactConfirm closeConfirmModal={closeConfirmModal} />
    </>
  );
};

export default UserBookings;
